import { create } from 'zustand';
import uuid from 'uuid';
import { PlaybackStateFilter, Sort } from '../enums';
import { PlaybackEvent, PlaybackEventEmitter } from '../events';
import { usePlaybackStateStore } from '../store';
const playlistContextToPlaylistContext = (ctx) => ({
    playbackState: PlaybackStateFilter.ALL,
    sortOrder: Sort.ASC,
    sortField: 'position',
    ...ctx,
});
export const usePlaylistStateStore = create((set, get) => ({
    setActivePlaylistContext: (ctx) => set(() => ({
        sessionId: uuid.v4(),
        activePlaylistContext: playlistContextToPlaylistContext(ctx),
    })),
    setActivePlaylistItems: (items) => set(() => ({
        activePlaylistItems: items,
    })),
    setAvailablePlaylistContext: (ctx) => set(() => {
        if (ctx.collection.isPlaylist === true) {
            return {
                availablePlaylistContext: playlistContextToPlaylistContext(ctx)
            };
        }
        else {
            return {
                availablePlaylistContext: undefined,
            };
        }
    }),
    promoteAvailablePlaylist: async (content) => {
        const { availablePlaylistContext, activePlaylistContext } = get();
        const availableId = availablePlaylistContext?.collection?.id;
        const activeId = activePlaylistContext?.collection?.id;
        const next = content || usePlaybackStateStore.getState().content;
        if (availableId && availableId !== activeId) {
            await PlaybackEventEmitter.emit(PlaybackEvent.STOP, { next });
            set({
                sessionId: uuid.v4(),
                activePlaylistContext: availablePlaylistContext,
                activePlaylistItems: undefined,
            });
            await PlaybackEventEmitter.emit(PlaybackEvent.ACTIVE_PLAYLIST_CONTEXT_UPDATED);
        }
        else if (!availableId) {
            if (usePlaybackStateStore.getState().content?.id !== content?.id) {
                await PlaybackEventEmitter.emit(PlaybackEvent.STOP, { next });
            }
            set({
                sessionId: uuid.v4(),
                activePlaylistContext: undefined,
                activePlaylistItems: next ? [next.id] : undefined,
            });
            await PlaybackEventEmitter.emit(PlaybackEvent.ACTIVE_PLAYLIST_CONTEXT_UPDATED);
        }
        else {
            set({});
        }
    },
}));
//# sourceMappingURL=usePlaylistStateStore.js.map